// utils/formatJournalPath.js

// "Current Molecular Pharmacology" → "current-molecular-pharmacology"
export const formatJournalPath = (name) => {
    return encodeURIComponent(
      name.toLowerCase().replace(/\s+/g, "-")
    );
  };
  
  // 将路径格式还原为正常期刊名，如：
  // "current-molecular-pharmacology" → "Current Molecular Pharmacology"
  export const parseJournalPath = (slug) => {
    const decoded = decodeURIComponent(slug.replace(/-/g, " "));
    // 可选：将每个单词首字母大写
    return decoded.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // Match by journal id (jcgb) or title slug (journal-of-computational-genomics-and-biology)
  export const findJournal = (journals, slug) => {
    if (!journals || !slug) return null;
    const decoded = decodeURIComponent(slug).toLowerCase();
    const parsedTitle = parseJournalPath(slug).toLowerCase();
    return (
      journals.find((item) => {
        if (item.id && String(item.id).toLowerCase() === decoded) return true;
        if (item.title && item.title.toLowerCase() === parsedTitle) return true;
        if (item.title && formatJournalPath(item.title).toLowerCase() === decoded)
          return true;
        return false;
      }) || null
    );
  };
  
  export default formatJournalPath;
  